import { render, staticRenderFns } from "./estadisticas-situacion-empresa-actual.vue?vue&type=template&id=4a4bbc45&scoped=true&"
import script from "./estadisticas-situacion-empresa-actual.vue?vue&type=script&lang=ts&"
export * from "./estadisticas-situacion-empresa-actual.vue?vue&type=script&lang=ts&"
import style0 from "./estadisticas-situacion-empresa-actual.vue?vue&type=style&index=0&id=4a4bbc45&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4bbc45",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow,VSpacer})
